/**
 * ListCategory
 */

import DropdownLayer from '../DropdownLayer';
import DropdownLayer2Depth from '../DropdownLayer2Depth';
import Config from '../Config';
import Util from '../Util';
import GameInfo from '../GameInfo';

class ListCategory {
  public onChange: any;

  public onInit: any;

  public onNull: any;

  private $parent: any;

  private value: any;

  private isSetDefault: boolean;

  private isFirstAppend: boolean;

  private dropdownLayer: any;

  constructor($parent: any, value: any, isSetDefault: boolean = false, isFirstAppend: boolean = false) {
    this.$parent = $parent;
    this.value = value;
    this.isSetDefault = isSetDefault;
    this.isFirstAppend = isFirstAppend;
    this.onChange = new Util.Observer();
    this.onInit = new Util.Observer();
    this.onNull = new Util.Observer();

    this.getCategory();
  }

  public setValue(val: any) {
    this.dropdownLayer.setValue(val);
  }

  public setCategoryUI(data: any) {
    const serverId = Config.serverName[GameInfo.getGameServerId()];
    let tmp: any[] = [];

    // 2Depth
    if (Config.isShowCategory2Depth) {
      tmp = Config.isUuid ? data.tree.root.children : data.categories;

      this.dropdownLayer = new DropdownLayer2Depth(this.$parent, tmp, 'boardCategory');
      this.dropdownLayer.addChange((dropDownData: any) => {
        if (dropDownData || dropDownData === 0) {
          this.onChange.emit(dropDownData);
        }
      });

      if (Util.getParams().categoryId) {
        this.dropdownLayer.setValue(Util.getParams().categoryId);
      } else if (Config.isShowCategory2DepthTotal) {
        this.dropdownLayer.setFirst();
      } else {
        this.dropdownLayer.setTextValue(serverId);
      }

      if (this.isFirstAppend) {
        this.$parent.prepend(this.dropdownLayer.getNode());
      }

      this.onInit.emit(this.dropdownLayer.getValue());
    } else if (Config.isCategory || Config.isShowCategory) {

      data = Util.DataFilter.filter(data, Config.isUuid?{boardActivated: true}:{ activated: true });

      data.forEach((item: any) => {
        tmp.push({
          key: Config.isUuid ? item.boardWrapper.board.id : item.categoryId,
          value: Config.isUuid ? item.boardWrapper.board.boardName : item.categoryName
        });
      });

      if (!tmp.length) {
        this.onNull.emit();
        return;
      }

      if (Config.isShowCategoryAll) {
        tmp.unshift({ key: '0', value: Config.L10N.all });
      }

      this.dropdownLayer = new DropdownLayer(this.$parent, tmp, 'boardCategory');
      this.dropdownLayer.addChange((dropDownData: any) => {
        if (dropDownData || dropDownData === 0) {
          this.onChange.emit(dropDownData);
        }
      });

      // show the FavTeam
      if (GameInfo.getFavTeamName() && Config.isCategory) {
        this.dropdownLayer.setTextValue(GameInfo.getFavTeamName());
        this.onInit.emit(this.dropdownLayer.getValue());
      } else if (Config.gameServerName && Config.isServerBoard) {
        // serverBoard
        this.dropdownLayer.setTextValue(Config.gameServerName);
        this.onInit.emit(this.dropdownLayer.getValue());
      } else if (this.isSetDefault) {
        // default param
        this.setValue(tmp[0].key);
        this.onInit.emit(tmp[0].key);
      }

      if (this.isFirstAppend) {
        this.$parent.prepend(this.dropdownLayer.getNode());
      }

      if (this.value) {
        this.setValue(this.value);
      }
    } else {
      this.onNull.emit();
    }
  }

  public getCategory() {
    const _post: any = Config.isShowCategory2Depth ? Util.get(Config.category2depth(Config.board), 'GET') : Util.get(Config.category(Config.board), 'GET');
    const post$ = Util.from(_post);
    post$.subscribe(
      (data: any) => {
        if (data) {
          // data = Util.convertCamelCase( data );

          if (data.depthCategories) {
            data = data.depthCategories;
          }

          this.setCategoryUI(data);
        } else {
          this.onNull.emit();
        }
      },
      (data: any) => {
        // this.onChange.emit( '' );
        this.onNull.emit();
        // Config.apiError( data );
      }
    );
  }
}

export default ListCategory;
